var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SectionHeader", {
    attrs: {
      "show-content": _vm.bidAdjustmentsShowContents,
      "widget-title": _vm.$t("HEADER_BID_ADJUSTMENTS")
    },
    on: {
      onShowContentsClick: function($event) {
        return _vm.onBidAdjustmentsShowContentsClick()
      }
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function() {
          return [
            _vm.overridesAvailable
              ? _c(
                  "div",
                  [
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("LABEL_OVERRIDE_BID_ADJUSTMENTS"),
                        "hide-label": false,
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t(
                          "TOOLTIP_OVERRIDE_BID_ADJUSTMENTS"
                        )
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "p-l-0 col-sm-5 col-md-1" },
                                  [
                                    _c(
                                      "ValidationProvider",
                                      {
                                        attrs: { rules: "required", slim: "" }
                                      },
                                      [
                                        _c("nzToggle", {
                                          attrs: {
                                            value: _vm.overrideBidAdjustments
                                          },
                                          on: {
                                            onToggle:
                                              _vm.overrideBidAdjustmentsToggle
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        2733565952
                      )
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.overridesAvailable || _vm.overrideBidAdjustments
              ? _c(
                  "div",
                  [
                    _c("DraggableTable", {
                      attrs: {
                        value: _vm.rows,
                        "current-row": _vm.currentRow,
                        "last-row-id": _vm.lastRowId,
                        "edit-row": _vm.editRow,
                        headers: _vm.headers,
                        "adjustment-panel-properties":
                          _vm.adjustmentPanelProperties,
                        "show-add-adjustment-button":
                          _vm.showAddAdjustmentButton,
                        "adjustments-changed": _vm.adjustmentsChanged
                      },
                      on: {
                        onShowRowAdjustment: _vm.onShowRowAdjustment,
                        onAddAdjustment: _vm.onAddAdjustment,
                        onEditAdjustment: _vm.onEditAdjustment,
                        onAddAdjustmentButtonClick:
                          _vm.onAddAdjustmentButtonClick,
                        onResetAdjustments: _vm.onResetAdjustments,
                        onSaveAdjustments: _vm.onSaveAdjustments,
                        onCancelAdjustments: _vm.onCancelAdjustments,
                        onOrderChange: _vm.onOrderChange,
                        drag: _vm.onDrag,
                        onSetCurrentRow: _vm.onSetCurrentRow,
                        onToggleEditRow: _vm.onToggleEditRow,
                        onRemoveRow: _vm.onRemoveRow
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "sanitizedRow",
                            fn: function({ row }) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "draggable__dragbutton" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "draggable__dragbutton-action",
                                        class: {
                                          "draggable-table-cursor": !_vm.showAddAdjustmentButton
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "glyphicon glyphicon-option-vertical",
                                          attrs: { "aria-hidden": "true" }
                                        }),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass:
                                            "glyphicon glyphicon-option-vertical",
                                          attrs: { "aria-hidden": "true" }
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.sanitizeRow(row), function(
                                  val,
                                  propertyName
                                ) {
                                  return _c(
                                    "span",
                                    {
                                      key: propertyName,
                                      class:
                                        "bid-adjustment-settings-summary__" +
                                        propertyName.toLowerCase()
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(val) +
                                          "\n          "
                                      )
                                    ]
                                  )
                                })
                              ]
                            }
                          },
                          {
                            key: "actions",
                            fn: function({ row, showRowAdjustment }) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "bid-adjustment-settings-summary__actions"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "actions-collapsed-list" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "btn btn-list-function action-icon",
                                            attrs: {
                                              href: "javascript:;",
                                              disabled:
                                                _vm.showAddAdjustmentButton
                                            },
                                            on: {
                                              mousedown: function($event) {
                                                !_vm.showAddAdjustmentButton
                                                  ? showRowAdjustment(row)
                                                  : null
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              directives: [
                                                {
                                                  name: "tooltip",
                                                  rawName:
                                                    "v-tooltip.bottom.hover",
                                                  value: {
                                                    text: _vm.$t(
                                                      "EDIT_BID_MODIFIER"
                                                    ),
                                                    transition: 0
                                                  },
                                                  expression:
                                                    "{text:$t('EDIT_BID_MODIFIER'), transition: 0}",
                                                  modifiers: {
                                                    bottom: true,
                                                    hover: true
                                                  }
                                                }
                                              ],
                                              staticClass: "typcn typcn-edit",
                                              attrs: { "aria-hidden": "true" }
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              directives: [
                                                {
                                                  name: "t",
                                                  rawName: "v-t",
                                                  value: "EDIT_BID_MODIFIER",
                                                  expression:
                                                    "'EDIT_BID_MODIFIER'"
                                                }
                                              ],
                                              staticClass: "hint-text-mobile"
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "btn btn-list-function action-icon",
                                            attrs: {
                                              href: "javascript:;",
                                              disabled:
                                                _vm.showAddAdjustmentButton
                                            },
                                            on: {
                                              mousedown: function($event) {
                                                !_vm.showAddAdjustmentButton
                                                  ? _vm.onRemoveRow(row)
                                                  : null
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              directives: [
                                                {
                                                  name: "tooltip",
                                                  rawName:
                                                    "v-tooltip.bottom.hover",
                                                  value: {
                                                    text: _vm.$t("DELETE"),
                                                    transition: 0
                                                  },
                                                  expression:
                                                    "{text:$t('DELETE'), transition: 0}",
                                                  modifiers: {
                                                    bottom: true,
                                                    hover: true
                                                  }
                                                }
                                              ],
                                              staticClass: "typcn typcn-trash",
                                              attrs: { "aria-hidden": "true" }
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              directives: [
                                                {
                                                  name: "t",
                                                  rawName: "v-t",
                                                  value: "DELETE",
                                                  expression: "'DELETE'"
                                                }
                                              ],
                                              staticClass: "hint-text-mobile"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1196897801
                      )
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }